<template>
  <div class="bg" >
    <v-nav></v-nav>
    <div class="answerpage">
    <div class="title">公告</div>
      <div class="listbox" style="height:10rem;">
        <ul v-if="newlists.length > 0">
           <li v-for="(item,index) in newlists" :key="index"><h3>{{item.content}}</h3><span>{{item.create_at}}</span></li>
        </ul>
        <div v-if="newlists.length == 0" class="nolist">
          <div class="nopic"><img src="../../assets/images/nopic.png"></div>
          <p>暂无公告</p>
        </div>
      </div>
      <!--<div class="title">疑问/留言</div>
      <div class="textarea">
        <textarea placeholder="请输入您的问题" v-model="content"></textarea>
      </div>
      <div class="put">
        <input type="text" placeholder="请输入您的姓名" v-model="username"/>
      </div>
      <div class="put">
        <input type="text" placeholder="请输入您的邮箱" v-model="email"/>
      </div>
      <div class="send" @click="sendForm">发送</div> -->
    </div>
  </div>
</template>

<script>
    export default {
        name: "answer",
        data() {
            return {
              newlists:[],
              content:'',
              username:'',
              email:''
            }
        },
        mounted() {
          this.getlist()
        },
        methods: {
        // 公告列表
        getlist(){
        this.$http({
            url: '/Mail/newslist',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
            a:1
            }
          }).then((res) => {
            if(res.status==200){
            for(let i=0;i<res.data.data.length;i++){
              res.data.data[i].content.replace(/(\n)/g, "");
              res.data.data[i].content.replace(/(\t)/g, "");
              res.data.data[i].content.replace(/(\r)/g, "");
              res.data.data[i].content.replace(/<V?[^>]>/g, "");
              res.data.data[i].content.replace(/\s/g, "");
            }
            this.newlists = res.data.data
            }else{
              this.$layer.msg('发送失败')
            }
          })
          .catch((error) => {
            this.$layer.msg('网络错误，请稍后重试')
            console.log(error)
          })
        },
          sendForm(){
            if(!this.content){
              this.$layer.msg('请输入您的问题')
              return
            }
            if(!this.username){
              this.$layer.msg('请输入您的姓名')
              return
            }
            var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if(!reg.test(this.email)){
              this.$layer.msg('请输入正确的邮箱')
              return
            }
            this.$http({
              url: '/mail/index',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                subject:'',
                body:this.content,
                username:this.username,
                email:this.email
              }
            }).then((res) => {
              console.log(res)
              if(res.status==200){
                this.$layer.msg('发送成功')
                this.content=''
                this.username=''
                this.email=''
              }else{
                this.$layer.msg('发送失败')
              }
            })
              .catch((error) => {
                this.$layer.msg('网络错误，请稍后重试')
                console.log(error)
              })
          }
        }
    }
</script>

<style scoped lang="scss">
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow: auto;
    background-size:100% 100%;
  }
.answerpage{
  padding:0 0.28rem;
  box-sizing: border-box;
  .title{
    font-size:0.32rem;
    color:#5f4009;
    padding:0.35rem 0;
  }
  .textarea{
    textarea{
      resize: none;
      height:7.2rem;
      border:1px solid #d0af81;
      border-radius:4px;
      width:100%;
      font-size:0.26rem;
      background: #fff;
      padding:0.2rem 0.2rem;
      box-sizing: border-box;
    }
  }
  .put{
    margin-top:0.3rem;
    input{
      font-size:0.26rem;
      width:100%;
      border:1px solid #d0af81;
      height:0.8rem;
      border-radius:4px;
      padding:0 0.2rem;
      box-sizing: border-box;
    }
  }
  .send{
    height:0.8rem;
    width:100%;
    background: #c9a168;
    color:#fff;
    text-align: center;
    line-height: 0.8rem;
    font-size:0.28rem;
    border-radius:4px;
    margin:0.5rem 0;
  }
    .listbox{
    background-color: #fff;
    width: 100%;
    height: 6rem;
    border-radius: 0.1rem;
    box-sizing: border-box;
    padding: 0.1rem 0;
    ul{
      padding: 0  0.4rem;
      box-sizing: border-box;
      overflow-y: auto;
      width: 100%;
      height: 100%;
      li{
        padding: 0.2rem 0;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        width: 100%;
        border-bottom: 0.02rem dashed #cda16d;
        line-height: 1.5;
        h3{
          flex: 1;
          font-size: 0.3rem;
          color: #624012;
          font-weight: 500;
        }
        span{
          text-align: right;
          width: 44%;
          font-size: 0.2rem;
          color: #624012;
        }
      }
    }
  }
  .nolist{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction:column;
      .nopic{
        width: 2rem;
        height: 1.3rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      p{
        font-size: 0.3rem;
        color: #666;
        text-align: center;
        margin-top: 0.2rem;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/m/answer.vue